<template>
  <div>
    <!--评估中心流程进度 -->
    <div>
      <div>
        评估中心流程进度
      </div>
      <div>
        用户ID: <el-input v-model="userId" placeholder="用户id"></el-input>
        recruitmentId: <el-input v-model="recruitmentId" placeholder="recruitmentId"></el-input>
        <el-button @click="openResumeEdit">编辑简历</el-button>
      </div>
      <div>
        <el-button @click="openCourseAbilityEdit">课程能力项关系新增/修改</el-button>
      </div>
      <div>
        <el-table
                :data="assessment.pastRecruitmentProessList"
                style="width: 100%"
                :row-key="getRowKeys"
                :row-class-name="getRowClass"
                :expand-row-keys="expands"
                @row-click="clickRowHandle">
          <el-table-column  type="expand"  >
            <template slot-scope="props" v-if="props.row.status === '进行中'" >
              <div  >
                <div style="background: #ffffff">
                  <el-row >
                    <el-col :span="3" class="container" style="height: 140px"><div class="dialog" >评估流程</div></el-col>
                    <el-col :span="2" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-个人简历-带文字图标.png" style="height: 80px; width: auto"></div></el-col>
                    <el-col :span="2" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-个人简历2工作成就-图标.png" style="height: auto; width: 80px"></div></el-col>
                    <el-col :span="2" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-个人简历-带文字图标.png" style="height: 80px; width: auto"></div></el-col>
                    <el-col :span="2" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-个人简历2工作成就-图标.png" style="height: auto; width: 80px"></div></el-col>
                    <el-col :span="3" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-个人简历-带文字图标.png" style="height: 100px; width: auto"></div></el-col>
                    <el-col :span="2" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-个人简历2工作成就-图标.png" style="height: auto; width: 80px"></div></el-col>
                    <el-col :span="3" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-工作成就-带文字图标-灰.png" style="height: 80px; width: auto"></div></el-col>
                    <el-col :span="2" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-个人简历2工作成就-图标.png" style="height: auto; width: 80px"></div></el-col>
                    <el-col :span="2" class="container" style="height: 140px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-工作成就-带文字图标-灰.png" style="height: 80px; width: auto"></div></el-col>
                    <el-col :span="1" class="container" style="height: 140px"><div class="dialog" > </div></el-col>
                  </el-row>
                </div>
                <el-divider></el-divider>
                <div style="background: #ffffff">
                  <el-row >
                    <el-col :span="3" class="container" style="height: 80px"><div class="dialog" >状态</div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog" > <img alt="" src="../../../../assets/img/resume/个人简历-添加按钮-图标.png" style="height: 30px; width: auto"></div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog" ><img alt="" src="../../../../assets/img/resume/个人简历-添加按钮-图标.png" style="height: 30px; width: auto"></div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                    <el-col :span="3" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                    <el-col :span="3" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                    <el-col :span="1" class="container" style="height: 80px"><div class="dialog" > </div></el-col>
                  </el-row>
                </div>
                <el-divider></el-divider>
                <div style="background: #ffffff">
                  <el-row >
                    <el-col :span="3" class="container" style="height: 80px"><div class="dialog" >操作入口</div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog2" > <el-link type="primary">点击进入</el-link> </div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog"></div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog2"><el-link type="primary">点击进入</el-link></div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog"></div></el-col>
                    <el-col :span="3" class="container" style="height: 80px"><div class="dialog2">请联系区域经理<el-tooltip class="item" effect="light" content="如不知道负责的区域经历是谁，请联系总店。" placement="right"><em class="el-icon-question"></em></el-tooltip></div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog"> </div></el-col>
                    <el-col :span="3" class="container" style="height: 80px"><div class="dialog"> </div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog"> </div></el-col>
                    <el-col :span="2" class="container" style="height: 80px"><div class="dialog"> </div></el-col>
                    <el-col :span="1" class="container" style="height: 80px"><div class="dialog"></div></el-col>
                  </el-row>
                </div>
              </div>
            </template>
          </el-table-column >
          <el-table-column
                  prop="userId"
                  label="申请评估职位">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="经销商">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="品牌">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="网店类型">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="评估次数">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="区域评估反馈">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="日期/场地">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="评估中心结果">
          </el-table-column>
          <el-table-column
                  prop="status"
                  label="评估中心状态">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="发展中心状态">
          </el-table-column>
          <el-table-column
                  prop="name"
                  label="个人发展计划">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "assessmentlist",
    data() {
      return {
        userId:'211308',
        recruitmentId:'1316646968107380737',
        assessment: {
          presentRecruitmentProessList: [
            {
              "recruitmentStepList": [
                {
                  "jobId": "250",
                  "stepDescribe": "提交简历",
                  "recruitmentStepConfId": "1309376737681805314",
                  "step": "1",
                  "updateTime": "",
                  "id": "1310046665734324225",
                  "recruitmentId": "1310046664295677953",
                  "isCanEdit": "10",
                  "status": "20"
                },
                {
                  "jobId": "250",
                  "stepDescribe": "在线测评",
                  "recruitmentStepConfId": "1309376737744719873",
                  "step": "2",
                  "updateTime": "",
                  "id": "1310046665734324226",
                  "recruitmentId": "1310046664295677953",
                  "isCanEdit": "10",
                  "status": "10"
                },
                {
                  "jobId": "250",
                  "stepDescribe": "区域评估",
                  "recruitmentStepConfId": "1309376737799245826",
                  "step": "3",
                  "updateTime": "",
                  "id": "1310046665734324227",
                  "recruitmentId": "1310046664295677953",
                  "isCanEdit": "10",
                  "status": "10"
                },
                {
                  "jobId": "250",
                  "stepDescribe": "能力评估",
                  "recruitmentStepConfId": "1309376737866354690",
                  "step": "4",
                  "updateTime": "",
                  "id": "1310046665734324228",
                  "recruitmentId": "1310046664295677953",
                  "isCanEdit": "10",
                  "status": "10"
                },
                {
                  "jobId": "250",
                  "stepDescribe": "完成",
                  "recruitmentStepConfId": "1309376737933463553",
                  "step": "5",
                  "updateTime": "",
                  "id": "1310046665734324229",
                  "recruitmentId": "1310046664295677953",
                  "isCanEdit": "10",
                  "status": "10"
                }
              ],
              "temp":[
                {
                  "jobName": "",
                  "networkTypeCode": "",
                  "recruitmentNum": "",
                  "jobCode": "",
                  "offeringNo": "",
                  "signUpEnddate": "",
                  "interviewResult": "",
                  "jobNameCn": "",
                  "panelAssessmentResult": "",
                  "userId": 1174499,
                  "orgId": 349,
                  "developmentResults": "",
                  "signUPDate": "",
                  "jobId": 250,
                  "personalDevelopmentPlan": "",
                  "signUpLocation": "",
                  "signUpLocationId": "","id": "1310046664295677953",
                  "networkType": "",
                  "brand": "",
                  "brandCode": "",
                  "status": "10"
                  }
              ],

            }
          ],
          pastRecruitmentProessList: [
            {
              "jobName": "",
              "networkTypeCode": "",
              "recruitmentNum": "",
              "jobCode": "",
              "offeringNo": "G00012356",
              "signUpEnddate": "2020-08-29 17:00:00",
              "interviewResult": "",
              "jobNameCn": "",
              "panelAssessmentResult": "",
              "userId": 1174499,
              "orgId": 349,
              "developmentResults": "",
              "signUPDate": "2020-08-29 09:00:00",
              "jobId": 36,
              "personalDevelopmentPlan": "",
              "signUpLocation": "BMW北京培训中心(新)",
              "signUpLocationId": "",
              "recruitmentStepList": "",
              "id": "1310046690233253890",
              "networkType": "",
              "brand": "",
              "brandCode": "",
              "status": "进行中"
            },
            {
              "jobName": "",
              "networkTypeCode": "",
              "recruitmentNum": "",
              "jobCode": "",
              "offeringNo": "G00012356",
              "signUpEnddate": "2020-08-29 17:00:00",
              "interviewResult": "",
              "jobNameCn": "",
              "panelAssessmentResult": "",
              "userId": 1174499,
              "orgId": 349,
              "developmentResults": "",
              "signUPDate": "2020-08-29 09:00:00",
              "jobId": 36,
              "personalDevelopmentPlan": "",
              "signUpLocation": "BMW北京培训中心(新)",
              "signUpLocationId": "",
              "recruitmentStepList": "",
              "id": "1310046690233253891",
              "networkType": "",
              "brand": "",
              "brandCode": "",
              "status": "已完成"
            }
          ]
        },
        // 获取row的key值
        getRowKeys(row) {
          return row.id;
        },
        // 要展开的行，数值的元素是row的key值
        expands: [],

        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }],
        tableData2: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }],
        tableData3: [
          {
            date: '2019-07-30 12:32:02',
            name: '提交简历',
            state: '1',
            onlinestate: '0',
            address: '对号'
          }, {
            date: '2019-08-01 13:32:02',
            name: '在线评测',
            state: '1',
            onlinestate: '1',
            address: '对号'
          }, {
            date: '2019-08-01 13:32:02',
            name: '区域评估',
            state: '0',
            onlinestate: '0',
            address: '对号'
          }, {
            date: '',
            name: '能力评估',
            state: '0',
            onlinestate: '0',
            address: '对号'
          }, {
            date: '',
            name: '完成',
            state: '0',
            onlinestate: '0',
            address: '对号'
          }]
      }

    },
    methods: {

      // 跳转编辑简历
      openResumeEdit(){
        this.$router.push({
          name: 'acdc-resume-resumeEdit',
          params: {
            userId: this.userId,
            recruitmentId:this.recruitmentId,
          }
        })
      },
      // 跳转 课程能力项关系新增/修改
      openCourseAbilityEdit(){
        this.$router.push({
          name: 'acdc-courseAbility-courseAbilityEdit',
          params: {
            userId: this.userId,
            recruitmentId:this.recruitmentId,
          }
        })
      },


      operationButton(scope) {
        console.log(scope)
        // 判断 第一行 如果状态是1 则显示
        if (scope.$index === 0) {
          if (scope.row.state === '1') {
            return true
          } else {
            return false
          }
        } else if (scope.$index === 1) {
          // 判断 第二行 如果状态是1 并且未填写过 则显示
          if (scope.row.state === '1' && scope.row.onlinestate === '1') {
            return true
          } else {
            return false
          }
        } else {
          // 其他行列全部不显示按钮
          return false
        }

      },


      clickRowHandle(row, column, event) {
        if(row.status === '进行中'){
          if (this.expands.includes(row.id)) {
            this.expands = this.expands.filter(val => val !== row.id);
          } else {
            this.expands.push(row.id);
          }
        }
      },

      // 下拉箭头是否显示
      getRowClass(row, rowIndex) {
        let data = row.row;
        // console.log('getRowClass '+data)

        let res = [];
        if (data.status === '进行中') {
          res.push('row-expand-has')
          return res;
        } else {
          res.push('row-expand-unhas')
          return res;
        }
      },



      /***
       * row为某一行的除操作外的全部数据
       * column为某一列的属性
       * rowIndex为某一行（从0开始数起）
       * columnIndex为某一列（从0开始数起）
       */
      cellStyle({row, column, rowIndex, columnIndex}) {
        // console.log('cellStyle')
        if (rowIndex === 3 && columnIndex === 0) {
          console.log('cellStyle')
          return "font-size: 18px; font-weight: 700;"
        }
      },

      headerRowClass({row, rowIndex}) {
        return "{background:'#eef1f6',color:'#606266'}"
      },
    }
  }
</script>

<style scoped>


  .container {
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    text-align: center;
    font-size: 0;
    white-space: nowrap;
    overflow: auto;
  }

  .container:after {
    content: '';
    display: inline-block;
    height: 100%;
    vertical-align: middle;
  }

  .dialog {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    font-size: 14px;
    white-space: normal;
    font-weight: 900;
  }

  .dialog2 {
    display: inline-block;
    vertical-align: middle;
    text-align: left;
    font-size: 14px;
    white-space: normal;
  }

  /*横条高度*/
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 2px 0;
  }
</style>
<style>
  .row-expand-unhas  .el-table__expand-column  .cell{
    visibility:hidden  ;
  }
</style>
